import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=d8ee715e&scoped=true"
import script from "./UploadPhoto.vue?vue&type=script&lang=js"
export * from "./UploadPhoto.vue?vue&type=script&lang=js"
import style0 from "./UploadPhoto.vue?vue&type=style&index=0&id=d8ee715e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ee715e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8ee715e')) {
      api.createRecord('d8ee715e', component.options)
    } else {
      api.reload('d8ee715e', component.options)
    }
    module.hot.accept("./UploadPhoto.vue?vue&type=template&id=d8ee715e&scoped=true", function () {
      api.rerender('d8ee715e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/verifiedPhotos/components/UploadPhoto.vue"
export default component.exports